import styled from 'styled-components';

export const Tag = styled.span`
    background: var(--standoutBg);
    padding: 4px 12px;
    border-radius: 15px;
    font-size: 80%;
    text-align: center;
`;